import React, { Component } from 'react';
import './checkout.css';

class Checkout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      isConfirmed: false,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(e) {
    this.setState({ name: e.target.value });
  }

  handleSubmit(e) {
    e.preventDefault();
    this.setState({ isConfirmed: true });
  }

  render() {
    const { name, isConfirmed } = this.state;

    return (
      <div className="checkout-wrapper">
        <h1 className="checkout-title">Finalizar Compra</h1>

        {isConfirmed ? (
          <div className="checkout-confirmation">
            <h2 className="confirmation-heading">Compra Confirmada!</h2>
            <p className="confirmation-message">
              Obrigado, <span className="confirmation-name">{name}</span>, pela sua compra. <br/>Você receberá um e-mail para finalizar o seu cadastro e ter acesso ao seu livro!
            </p>
          </div>
        ) : (
          <form onSubmit={this.handleSubmit} className="checkout-form">
            <div className="book-card">
              <div className="book-cover" style={{backgroundImage: `url("https://storage-aws-production.publica.la/bookwire-brazil/issues/2025/04/yQQpZlYxYiqWszaY/f1ea72d7-dbb1-4a75-8930-fc7831b646fd_cover.jpg")`}}></div>
              <div className="book-info">
                <p className="book-title">Bases de Confeitaria <br/>
                  <span className="book-author">Michelle Marine</span>
                </p>
                <p className="book-price">R$70 <span className="old-price">R$100</span></p>
                </div>
              </div>

            <label className="form-label">Nome completo</label>
            <input
              type="text"
              className="form-input"
              value={name}
              onChange={this.handleChange}
              required
            />

            <label className="form-label">E-mail</label>
            <input type="text" className="form-input" required />

            <label className="form-label">Número do cartão</label>
            <input type="text" className="form-input" required />

            <label className="form-label">Validade</label>
            <input type="text" className="form-input" placeholder="MM/AA" required />

            <label className="form-label">CVV</label>
            <input type="text" className="form-input" required />

            <button type="submit" className="form-button">Confirmar Compra</button>
          </form>
        )}
      </div>
    );
  }
}

export default Checkout;
